var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutrients({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Nutrients.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Nutrients",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(70.2019,38.604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c -0.33,-0.192 -0.557,-0.57 -0.607,-1.01 l -0.015,-0.156 v -6.479 c 1.225,-0.58 2.311,-1.423 3.17,-2.467 1.626,-1.976 2.342,-4.471 2.016,-7.029 -0.52,-4.074 -3.723,-7.327 -7.788,-7.909 -0.449,-0.062 -0.897,-0.095 -1.333,-0.095 -1.578,0 -3.11,0.398 -4.467,1.155 -1.733,-0.967 -3.739,-1.347 -5.797,-1.06 -4.068,0.582 -7.271,3.835 -7.791,7.909 -0.326,2.558 0.39,5.053 2.016,7.029 0.859,1.044 1.945,1.887 3.17,2.467 l -0.014,6.633 c -0.051,0.442 -0.278,0.82 -0.607,1.012 -4.077,2.385 -7.199,6.219 -9.006,10.797 l -6.129,-32.568 c -0.626,-3.557 -3.596,-6.05 -7.221,-6.05 -3.566,0 -6.527,2.442 -7.201,5.938 l -6.417,33.411 c -0.358,2.027 0.192,4.078 1.505,5.645 1.161,1.384 2.799,2.246 4.575,2.428 l -1.96,6.181 c -0.451,1.424 -0.209,2.924 0.664,4.115 0.727,0.996 1.822,1.656 3.022,1.849 l 0.753,10.618 c 0.194,2.608 2.388,4.647 4.994,4.647 2.715,0 4.917,-2.149 5.012,-4.891 0.075,-2.133 0.451,-7.158 0.709,-10.478 1.209,-0.188 2.315,-0.851 3.049,-1.853 0.873,-1.193 1.114,-2.693 0.663,-4.116 l -1.927,-6.076 c 1.648,-0.177 3.17,-0.945 4.304,-2.167 -0.092,0.89 -0.149,1.79 -0.149,2.702 0,12.467 8.875,22.609 19.783,22.609 10.908,0 19.782,-10.142 19.782,-22.609 C 10.758,11.598 6.636,3.884 0,0 m 0.083,50.302 c -22.922,12.637 -51.749,4.3 -64.386,-18.621 -12.638,-22.922 -4.301,-51.749 18.621,-64.386 22.922,-12.638 51.748,-4.301 64.386,18.621 12.637,22.922 4.301,51.748 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(44.9523,58.7358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,10.522 7.264,19.052 16.226,19.052 8.961,0 16.225,-8.53 16.225,-19.052 0,-7.473 -3.664,-13.94 -8.997,-17.062 -1.33,-0.778 -2.172,-2.16 -2.346,-3.675 -1.472,-0.846 -3.14,-1.306 -4.882,-1.306 -1.742,0 -3.411,0.46 -4.883,1.306 -0.174,1.515 -1.015,2.897 -2.345,3.675 C 3.664,-13.94 0,-7.473 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(71.2373,21.9141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.316,-2.473 -2.295,-4.485 -4.763,-4.838 -0.28,-0.04 -0.557,-0.06 -0.83,-0.06 -1.82,0 -3.435,0.867 -4.466,2.206 -1.032,-1.339 -2.646,-2.206 -4.467,-2.206 -0.272,0 -0.549,0.02 -0.83,0.06 -2.468,0.353 -4.447,2.365 -4.763,4.838 -0.423,3.316 2.036,6.152 5.214,6.363 v 5.194 c 1.503,-0.681 3.147,-1.043 4.846,-1.043 1.699,0 3.342,0.362 4.845,1.043 V 6.363 C -2.036,6.152 0.423,3.316 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(24.7183,66.8518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.268,0 0.542,-0.105 0.767,-0.347 0.218,-0.235 0.498,-0.342 0.772,-0.342 0.521,0 1.026,0.383 1.068,0.991 l 0.962,13.554 c 0.056,0.754 0.679,1.35 1.447,1.35 0.805,0 1.429,-0.653 1.458,-1.458 0.118,-3.395 0.95,-13.555 0.95,-13.555 0.043,-0.608 0.547,-0.99 1.068,-0.99 0.275,0 0.554,0.106 0.773,0.342 0.224,0.242 0.498,0.346 0.766,0.346 0.655,0 1.271,-0.623 1.027,-1.39 L 8.915,-8.258 C 8.775,-8.701 8.364,-9 7.902,-9 7.896,-9 7.891,-9 7.886,-9 l -5.764,0.085 c -0.458,0.007 -0.86,0.306 -0.998,0.742 l -2.151,6.782 C -1.27,-0.623 -0.654,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(39.7894,50.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -6.268,-33.302 c -0.361,-2.089 -2.042,-3.134 -3.723,-3.134 -1.676,0 -3.353,1.04 -3.72,3.121 l -1.503,6.594 c 0.183,-0.009 0.183,-0.025 0.366,-0.025 2.233,0 4.413,0.677 6.29,1.976 0.437,0.301 0.546,0.9 0.244,1.336 -0.186,0.27 -0.486,0.414 -0.791,0.414 -0.188,0 -0.378,-0.055 -0.545,-0.17 -1.552,-1.074 -3.351,-1.629 -5.196,-1.629 -0.297,0 -0.596,0.015 -0.895,0.044 l -0.93,5.274 c 0.608,-0.1 1.218,-0.157 1.823,-0.157 2.234,0 4.413,0.676 6.29,1.975 0.437,0.302 0.546,0.9 0.244,1.336 -0.186,0.27 -0.486,0.414 -0.791,0.414 -0.188,0 -0.378,-0.055 -0.545,-0.17 -1.584,-1.096 -3.394,-1.618 -5.188,-1.618 -0.74,0 -1.477,0.089 -2.194,0.263 l -0.94,5.334 c 0.365,-0.106 0.736,-0.195 1.115,-0.264 0.67,-0.122 1.342,-0.183 2.009,-0.183 2.233,0 4.413,0.677 6.29,1.975 0.437,0.302 0.546,0.901 0.244,1.337 -0.186,0.269 -0.486,0.414 -0.791,0.414 -0.188,0 -0.378,-0.055 -0.545,-0.171 -1.586,-1.097 -3.399,-1.622 -5.194,-1.622 -1.203,0 -2.398,0.236 -3.513,0.693 l -1.752,9.934 c -0.36,2.044 1.212,3.919 3.289,3.919 H -3.29 C -1.219,3.908 0.353,2.041 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrients);
export default __webpack_public_path__ + "static/media/nutrients.1824e22b271efc7ba3b20d30f260da9a.svg";
export { ForwardRef as ReactComponent };